import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MCHttpWrapperService, MCRootStoreService, MCConfigService } from '@maslul/common-services';

/**
 * MI-level HTTP wrapper that extends MCHttpWrapperService.
 * When the current route is under "request" (e.g. request/:guid or new-request),
 * URLs are built as: Api/auth/{ServiceName}
 * Otherwise, the default URL building is used: baseApiUrl + url
 */
@Injectable({
  providedIn: 'root'
})
export class MIHttpWrapperService extends MCHttpWrapperService {

  private readonly AUTH_PREFIX = 'Apiauth/';
  private readonly REQUEST_ROUTE_PATTERN = '/request/';

  constructor(
    protected override http: HttpClient,
    protected override rootStoreService: MCRootStoreService,
    protected override configService: MCConfigService,
    private router: Router
  ) {
    super(http, rootStoreService, configService);
  }

  protected override buildUrl(url: string): string {
    if (this.isUnderRequestRoute()) {
      return this.baseApiUrl + this.addAuthPrefix(url);
    }
    return this.baseApiUrl + url;
  }

  /**
   * Checks if the current route is under a request context (e.g. /request/:guid)
   */
  private isUnderRequestRoute(): boolean {
    const pathname = window.location.pathname;
    return pathname.includes(this.REQUEST_ROUTE_PATTERN);
  }

  /**
   * Transforms a URL like "Api/MICodeList/..." to "Api/auth/MICodeList/..."
   * If the URL already starts with "Api/", inserts "auth/" after "Api/"
   */
  private addAuthPrefix(url: string): string {
    if (url.startsWith('Api/')) {
      return this.AUTH_PREFIX+ url.substring(4);
    }
    if (url.startsWith('api/')) {
      return this.AUTH_PREFIX + url.substring(4);
    }
    return this.AUTH_PREFIX + url;
  }
}
